import { useMutation } from '@apollo/client'
import { Button, useMessage, useModal } from '@faceup/ui-base'
import { graphql } from '../__generated__'

type UnlinkCompanyFromPartnerProps = {
  motherId: string
  partnerId: string
}

const mutations = {
  UnlinkCompanyFromPartner: graphql(`
    mutation unlinkCompanyFromPartnerMutation($input: UnlinkCompanyFromPartnerInput!) {
      unlinkCompanyFromPartner(input: $input) {
        success
      }
    }
  `),
}

export const UnlinkCompanyFromPartner = ({
  partnerId,
  motherId,
}: UnlinkCompanyFromPartnerProps) => {
  const message = useMessage()
  const modal = useModal()
  const [unlinkCompanyFromPartner, { loading: isLoading }] = useMutation(
    mutations.UnlinkCompanyFromPartner,
    {
      refetchQueries: ['InstitutionQuery'],
      onCompleted: data => {
        if (data.unlinkCompanyFromPartner?.success) {
          return message.success('Company unlinked')
        }
        return message.error(
          'Company not unlinked. Does it have at least one active member, except the partner one? Please check also that owner is not the partner user.'
        )
      },
    }
  )

  const showConfirmationModal = () => {
    modal.confirm.danger({
      title: `Unlink company from partner`,
      content: `Do you really want to unlink this company from partner? This will remove access of all partner-users to this company. If later you'd like to add the partner again the users will need to be added manually.`,
      onConfirm: () =>
        unlinkCompanyFromPartner({
          variables: {
            input: {
              partnerId,
              motherId,
            },
          },
        }),
    })
  }

  return (
    <Button ghost type='primary' onClick={() => showConfirmationModal()} loading={isLoading}>
      Unlink partner
    </Button>
  )
}
